import React, { Component } from 'react';
import Moment from 'react-moment';
import DeleteModal from '../business-case-delete-modal';

class BusinessCaseSummaryView extends Component {
  state = {
    modalIsOpen: false,
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  activateBusinessCase = setFormToEdit => () => {
    const { onActivateBusinessCase, businessCaseItem } = this.props;
    onActivateBusinessCase({ bcbId: businessCaseItem.bcbId, setFormToEdit });
  };

  render() {
    const {
      businessCaseItem: { bcbName, bcbObjective, createdDate, updatedDate },
      authorableText: { dateText, deleteButtonText },
      id, reducedView, hideEditButton, isWidget, businessCaseItem,
    } = this.props;
    const { deleteBusinessCase } = this.props.actions;
    const SET_FORM_EDIT_TRUE = true;
    const SET_FORM_EDIT_FALSE = false;
    return (
      <div className={`${!isWidget ? 'ml-0 row' : ''}`}>
        <div className={`${!isWidget ? 'col-10' : ''}`}>
          <div className={`${!isWidget ? 'row' : ''}`}>
            <div className="d-flex">
              <div className="font-weight-bold summary-id">{id + 1}</div>
              <div className="pl-3">
                <a
                  className="font-weight-bold summary-title"
                  onClick={this.activateBusinessCase(SET_FORM_EDIT_FALSE)}
                  role="link"
                  tabIndex="0"
                >{bcbName}</a>
                {!reducedView && <p className="summary-objective">{bcbObjective}</p>}
                <div className="d-flex justify-content-start summary-dates">
                  <div className="summary-date">
                    <div>{dateText.created}</div>
                    <Moment format="DD / MM / YY">{createdDate}</Moment>
                  </div>
                  <div className="summary-date">
                    <div>{dateText.modified}</div>
                    <Moment format="DD / MM / YY">{updatedDate}</Moment>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {!isWidget &&
        <div className="col-2 d-flex flex-column justify-content-between align-items-end">
          {hideEditButton
            ? null
            : <button
              className="edit-button"
              onClick={this.activateBusinessCase(SET_FORM_EDIT_TRUE)}
              tabIndex="0"
            >
              <i className="td-icon icon-register" />
            </button>
          }
          {!reducedView &&
          <button
            className="delete-button"
            onClick={this.openModal}
            tabIndex="0"
          >
            <i className="td-icon icon-round-cross" />
          </button>
          }
          <DeleteModal
            deleteButtonText={deleteButtonText}
            deleteBusinessCase={deleteBusinessCase}
            businessCaseItem={businessCaseItem}
            modalIsOpen={this.state.modalIsOpen}
            closeModal={this.closeModal}
          />
        </div>
        }
      </div>
    );
  }
}

export default BusinessCaseSummaryView;
